import { Link } from 'react-router-dom';

function ViewAllButton({ label = 'View All Courses', variant = 'light', to }) {
  const styles =
    variant === 'dark'
      ? 'rounded-lg border border-white/20 bg-white px-6 py-3.5 text-base font-semibold text-[#9369CC] shadow-sm hover:border-[#9369CC] hover:bg-[#9369CC] hover:text-white hover:shadow-md'
      : 'rounded-lg border border-[#9369CC]/20 bg-white px-6 py-3.5 text-base font-semibold text-[#9369CC] shadow-md hover:border-[#9369CC] hover:bg-[#9369CC] hover:text-white hover:shadow-md';

  const content = (
    <>
      {label}
      <svg
        className="h-6 w-6 shrink-0 transition-transform duration-300 ease-out group-hover:rotate-90"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M5.4 20L4 18.6L15.6 7H9V5H19V15H17V8.4L5.4 20Z"
          fill="currentColor"
        />
      </svg>
    </>
  );

  const className = `group inline-flex items-center gap-2 transition-all duration-300 ease-out ${styles}`;

  if (to) {
    return (
      <Link to={to} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" className={className}>
      {content}
    </button>
  );
}

export default ViewAllButton;
